<template>
<div class="card">
   <h6>YOUR CURRENT ENERGY SUPPLY</h6>
   <h4>Electricity Usage</h4>

   <uiv-tabs justified @change="onUsageTabChange(usageTab)" v-model="usageTab">
      <uiv-tab>
        <div slot="title">
          Actual Figures
          <button type="button" class="btn-i" v-if="quote.electricityUsage.usageType == 1" v-uiv-tooltip.right="'You will find your electricity consumption on your latest bill'">i</button>
          <button type="button" class="btn-i" v-if="quote.electricityUsage.usageType == 0" v-uiv-tooltip.right="'You will find your electricity spend on your latest bill'">i</button>
        </div>

         <div class="row _margin-top-30">
            <div class="col-sm-4 _margin-bottom-10">
               <select-list
                  id="electricityUsageUsageType"
                  v-model="quote.electricityUsage.usageType"
                  :list="usageTypeList"
                  :disabled="quote.electricityUsage.disabledUnits"
                  @change="onReset"
               />
            </div>

            <div class="col-xs-12 col-sm-3 _margin-bottom-10">
               <validation-messages label="Spend" :$v="$v.cost" v-if="quote.electricityUsage.usageType == 0">
                  <div class="input-group left">
                     <div class="input-group-addon">£</div>
                     <form-field
                        id="electricityUsageCost"
                        type="number"
                        v-model.number="quote.electricityUsage.cost"
                        :error="$v.cost.$error"
                        @change="$v.cost.$touch()"
                     />
                  </div>
               </validation-messages>
               
               <validation-messages label="kWh" :$v="$v.usage" v-if="quote.electricityUsage.usageType == 1">
                  <div class="input-group right">
                     <form-field
                        id="electricityUsageUsage"
                        type="number"
                        v-model="quote.electricityUsage.usage"
                        :error="$v.usage.$error"
                        @change="$v.usage.$touch()"
                     />
                     <div class="input-group-addon">kWh</div>
                  </div>
               </validation-messages>
            </div>

            <div class="col-sm-5 _margin-bottom-10">
              <select-list
                id="electricityUsageUsageUnit"
                v-model="quote.electricityUsage.usageUnit"
                :list="usageUnitList"
              />
            </div>
         </div>
      </uiv-tab>

      <uiv-tab title="Help Me Estimate" :disabled="quote.electricityUsage.usageType == 0">
         <div v-show="quote.electricityUsage.usage !== ''">
             <h6 class="_margin-bottom-10">Electricity Usage</h6>
             <h4 class="_margin-top-0">{{ quote.electricityUsage.usage | number }} <small>kWh</small></h4>

            <uiv-btn type="ghost"
               size="sm"
               class="_margin-bottom-20"
               @click="onEstimate">New Estimate</uiv-btn>
         </div>

         <div v-show="quote.electricityUsage.usage === ''">
            <p>We can provide you an annual consumption estimate by answering a few short questions</p>

            <uiv-btn type="ghost"
               size="sm"
               class="_margin-bottom-20"
               @click="onEstimate">Help Me Estimate</uiv-btn>
         </div>

         <help-me-estimate
            ref="helpEstimate"
            @onClose="onCloseModal" />
      </uiv-tab>

      <uiv-tab title="Use Ofgem Averages" :disabled="quote.electricityUsage.usageType == 0">
         <div class="row _margin-top-30">
            <div class="col-xs-4 col-md-3" v-for="item in ofgemAverageList()" :key="item.label">
               <radio-button v-model="quote.electricityUsage.usage"
                              :value="item.value"
                              :error="$v.usage.$error">{{ item.label }}</radio-button>
            </div>
         </div>
      </uiv-tab>
   </uiv-tabs>
</div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import HelpMeEstimate from './HelpMeEstimate';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'UsageElectricity',
  data () {
    return {
      requesting: false,
      usageTab: 0,
      estimateModalOpen: false
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapGetters({
      is02Meter: 'quote/is02Meter'
    }),
    ...mapState({
      ofgemAverages: ({ ofgem_averages }) => ofgem_averages.averages,
      quote: ({ quote }) => quote,
      usageTypeList: ({ lookups }) => lookups.usageTypes,
      usageUnitList: ({ lookups }) => lookups.usageUnits
    })
  },
  methods: {
    ...mapActions({
      getEstimateList: 'lookups/getEstimateList'
    }),
    onReset () {
      this.quote.electricityUsage.usage = '';
      this.quote.electricityUsage.cost = '';
      this.quote.electricityUsage.usageUnit = 1;
    },
    onEstimate () {
      this.$refs.helpEstimate.openModal();
    },
    onUsageTabChange (index) {
      if (index === 1) {
         this.getEstimateList();
      } else {
         this.$v.usage.$reset();
      }

      this.onReset();
    },
    onCloseModal ({ electricityUsage }) {
      this.onReset();
      this.quote.electricityUsage.usage = electricityUsage;
    },
    ofgemAverageList () {
      if (this.is02Meter) {
        return this.ofgemAverages.electricity02;
      }

      return this.ofgemAverages.electricity01;
    }
  },
  components: {
    RadioButton,
    HelpMeEstimate
  }
};
</script>

<style lang="scss">
</style>
